<div class="status-pill" [ngClass]="getStatusClass()">
  <span class="status-text">{{ getLabel() }}</span>
  <mat-icon class="status-icon" aria-hidden="true">{{ getIcon() }}</mat-icon>
</div>
